/**
 * generic slick init functions
 * can be ignored by adding the '.custom' class to the slider
 * @param {Object} slider
 */

 //@codekit-prepend "slick-carousel";

function coreSliderInit(slider) {

    var numberOfSlides = slider.children().length;

    if (numberOfSlides <= 1) {

        console.log('CORE: no slides found in ' + slider.attr('class'));
        slider.css('opacity', 1);
        return;
    }

    var slickSettings = {

        autoplay: false,
        arrows: true,
        dots: true,
        adaptiveHeight: false,
        prevArrow: '<button aria-label="Previous button" class="slick-prev"><i class="far fa-arrow-circle-left"></i></button>',
        nextArrow: '<button aria-label="Next button" class="slick-next"><i class="far fa-arrow-circle-right"></i></button>',
        autoplaySpeed: 5000

    };

    if (jQuery(window).width() > coreVariables.breakpoints.md) {

        slickSettings.arrows = false;

    }

    slider.slick(slickSettings);

}

jQuery(document).ready(function() {

    //fire up sliders
    var sliders = jQuery('.core-slider').not('.custom');

    sliders.each((index, slider) => {

        if( !slider.classList.contains('slick-initialized') ) {

            slider = jQuery(slider);

            //init events must be set before firing up the slider
            slider.on('init', function() {

                //do things after the slider is setup
                console.log('CORE: slider loaded: ' + slider.attr('class'));

                //add dot icons
                jQuery('.slick-dots li button').html('<i class="fas fa-circle"></i>');

            });

            coreSliderInit(slider);

        }

    });

});